<style scoped>
    @import url("../../../styles/smartControl/formAgendDefDay.scss");
</style>

<template>
    <div class="box_formAgendDD">

        <div class="mainTit mb-2">
            <span>NOVO AGENDAMENTO</span>
        </div>

        <div class="menuForm">

            <div class="linhaForm">
                <span class="tLinha">Data:</span><span class="ml-2">Diariamente</span>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Horário:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        :placeholder="formLocal.hhmm"
                        @change="atualizarFormulario('hhmm')"
                    />
                    <!-- placeholder="15:01" -->
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="deviceSelected"
                    :items="liDevicesExib"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarDevice"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Título Atuador:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="atuadorSelected"
                    :items="liSelectAtuador"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarAtuador"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Tipo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="tipoSelected"
                    :items="liSelectTipo"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarTipo"
                    ></v-autocomplete>
                </div>
            </div>

            <!-- A atuação depende do tipo de atuação definido acima -->
            <div class="linhaForm" v-if="tipoSelected == 'Temporizado'">
                <span class="tLinha">Tempo:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.timeout_tempo_hr"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        :placeholder="formLocal.timeout_tempo_hr"
                        @change="atualizarFormulario('timeout')"
                    />
                </div>
            </div>
            <div class="linhaForm" v-else>
                <span class="tLinha">Atuação:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="formLocal.atu"
                    :items="liSelectComando"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarComando"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Porta:</span>
                <v-chip class="ml-2" color="#397E9E">{{ formLocal.pino_atuador }}</v-chip>
            </div>
        </div>

        <v-btn @click="addAgend()"
        class="mt-2"
        block 
        :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
        >adicionar</v-btn>

        <div v-if="flagMsgErro" class="mt-1" :style="{'align-self':'center','color':'red','font-size':'0.8rem'}">Preencha todos os campos.</div>
    </div>
</template>

<script>
import axios from 'axios'

export default {

    props:['emailCliente','sysSelected'],

    data() {
        return {

            //
            formLocal: {},     // cópia para edição
            flagMsgErro:false,
            hrUtcBeforeEdit:'22:01',

            //
            liSelectAtuador:[], // usada quando (flagNovoAgend==true)
            atuadorSelected:'', // usado quando (flagNovoAgend==true)
            deviceSelected:'', // usado quando (flagNovoAgend==true) | 14/10/2025
            device_id_current:'', // recorte do device id a partir da seleção do nome device exibição.
            atuante_tag:'',
            
            liSelectTipo:['Direto','Temporizado'],
            liSelectComando:['Ligar','Desligar'],
            tipoSelected:'',

            //comandoFront:'', // substituido por formLocal.comandoFront
            liDevices:[], // -- 14/10/2025 (lista de dispositivos controladores cadastrados nesse cliente)
            liDevicesExib:[],
        }
    },

    methods: {

        addAgend() {
            //console.log('formLocal: ',this.formLocal)
            this.formLocal['device'] = this.deviceSelected // <-- ainda não atribuído no obj até nesse ponto.
            
            // -- validar: todos os campos foram preenchidos? "atu" não entra pois pode ser também "timeout_tempo_hr"
            const required = ["hhmm","device","titulo_atuador","tipo","pino_atuador","command_hex","op"];
            const hasAllFields = required.every(
                k => this.formLocal[k] !== undefined && this.formLocal[k] !== null && this.formLocal[k] !== ""
            );
            
            if (hasAllFields) { this.$emit('formResult',this.formLocal); this.flagMsgErro = false } // reset
            else { this.flagMsgErro = true }
        },

        HHMMSStoSegundos(hhmmss) {
            // Quebra a string "HH:MM:SS" em partes
            const [h, m, s] = hhmmss.split(":").map(Number);
            // Converte para inteiro em segundos
            return (h * 3600) + (m * 60) + s;
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },

        atualizarFormulario(flagStr) { 
            
            // ---> garantir que o usuário digitou corretamente no formato correto esperado.
            // senao, atribui valor string seguro.

            if (flagStr == 'timeout') {
                let s = (this.formLocal.timeout_tempo_hr || '').trim()
                // sanear para HH:MM:SS se quiser (regex/parse)
                if (!/^\d{2}:\d{2}:\d{2}$/.test(s)) {
                    this.formLocal.timeout_tempo_hr = "00:00:01"

                    this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                    this.colorMsg = '#ec5858' // vermelho suave
                    this.flagMsgForm = true
                }
                else {
                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                }
            }

            if (flagStr == 'hhmm') {
                let s = (this.formLocal.hr_utc || '').trim()
                // sanear para HH:MM:SS se quiser (regex/parse)
                if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(s)) {
                    //this.formLocal.hr_utc = "22:01"
                    // --> obter valor anterior á edição.
                    this.formLocal.hr_utc = this.hrUtcBeforeEdit ?? this.formLocal.hr_utc

                    this.msgForm = 'Formato 00:01 obrigatório para as horas de 00:01 até 23:59.'
                    this.colorMsg = '#ec5858' // vermelho suave
                    this.flagMsgForm = true
                }
                else {
                    //this.hrUtcBeforeEdit = s // update backup horario

                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                }
            }
        },

        trocarDevice(deviceSelected) { 
            //console.log('this.liDevices: ',this.liDevices)
            let c=0
            while (c < this.liDevices.length) {
                //console.log('deviceSelected: ',deviceSelected) 
                //console.log('this.liDevices[c][nome_device]: ',this.liDevices[c]['nome_device']) 
                if (this.liDevices[c]['nome_device'] == deviceSelected) {

                    this.device_id_current = this.liDevices[c]['device'] // 17/10/2025
                    
                    this.liGeralDispositivo = this.liDevices[c]['liAtuadores'] // init this.liGeralDispositivo
                    let j=0
                    while (j < this.liGeralDispositivo.length) {
                        this.liSelectAtuador.push(this.liGeralDispositivo[j]['tit']) // recortar tit
                        j++
                    }
                    //console.log('this.liSelectAtuador: ',this.liSelectAtuador)
                    c=this.liDevices.length // break
                }
                c++
            }
        },

        trocarAtuador(atuadorSelected) {
            //console.log('atuadorSelected: ',atuadorSelected)

            this.formLocal.titulo_atuador = atuadorSelected // local form update

            let c=0;
            while (c < this.liGeralDispositivo.length) {
                //console.log('this.liGeralDispositivo[c][tit]: ',this.liGeralDispositivo[c]['tit'])
                //console.log('atuadorSelected: ',atuadorSelected)
                if (this.liGeralDispositivo[c]['tit'] == atuadorSelected) {
                    //console.log('this.liGeralDispositivo[c][porta]: ',this.liGeralDispositivo[c]['porta'])
                    this.formLocal.pino_atuador = this.liGeralDispositivo[c]['porta']
                    this.atuante_tag = this.liGeralDispositivo[c]['atuante'] // 17/10/2025 | init atuante

                    //console.log('this.formLocal.pino_atuador: ',this.formLocal.pino_atuador)
                    if (!this.tipoSelected || this.tipoSelected.trim() === '') {
                        //console.log('[trocarAtuador] tipoSelected: ',this.tipoSelected)
                        this.trocarTipo('Direto') // padrão para novo agendamento
                        //console.log('[trocarAtuador] após func tipoSelected: ',this.tipoSelected)
                        return
                    } else {
                        this.trocarTipo(this.tipoSelected)
                        return
                    }
                }
                c++
            }
        },

        trocarTipo(tipoSelected) {
            //console.log('tipoSelected: ',tipoSelected)
            //console.log('this.formLocal.timeout_tempo_hr: ',this.formLocal.timeout_tempo_hr)
            //console.log('this.comandoFront: ',this.comandoFront)
            
            if (tipoSelected == 'Temporizado') {
                this.tipoSelected = tipoSelected // local var -> global scope var
                
                if (this.formLocal.timeout_tempo_hr == undefined) { // senao for vazio
                    // -- obter valor em segundos mínimo (formato hhmmss)
                    const segundos_exib = this.segundosParaHHMMSS(1) // int -> string
                    //console.log('segundos_exib: ',segundos_exib)
                    this.formLocal.timeout_tempo_hr = segundos_exib // string
                    // --> nota: os segundos enviados para o server devem ser inteiros (parseInt).
                    //this.formLocal.op = 'Timeout' // +1 local form update
                }
                else{ this.formLocal.timeout_tempo_hr = "00:00:01"; }

                this.formLocal.command_hex = '06' + this.formLocal.pino_atuador // fixo
                this.formLocal.op = 'Timeout' // +1 local form update
            }
            
            if (tipoSelected == 'Direto') {
                this.tipoSelected = tipoSelected // local var -> global scope var
                //console.log('[trocarTipo] tipoSelected: ',tipoSelected)
                // --> !this.comandoFront cobre null, undefined, '', 0, false.
                // --> .trim() === '' cobre o caso de vir " " (string só de espaços).
                if (!this.formLocal.atu || this.formLocal.atu.trim() === '') {
                    //this.comandoFront = 'desligar' // descontinuado 08/01/2026
                    this.formLocal.atu = 'Desligar'
                    //console.log('[trocarTipo] this.comandoFront: ',this.comandoFront)
                }
                this.trocarComando(this.formLocal.atu) // update --> habilitar btn "verificar"
                this.formLocal.op = 'Direto' // +1 local form update
            }
        },

        trocarComando(comandoFront) {
            //console.log('comandoFront: ',comandoFront)
            
            if (comandoFront == 'Desligar') {
                this.formLocal.command_hex = '09' + this.formLocal.pino_atuador
                //console.log('this.formLocal.command_hex: ',this.formLocal.command_hex)
            }
            if (comandoFront == 'Ligar') {
                this.formLocal.command_hex = '08' + this.formLocal.pino_atuador
                //console.log('this.formLocal.command_hex: ',this.formLocal.command_hex)
            }
        },

        normalizeForm(obj) {
            const out = structuredClone?.(obj) ?? JSON.parse(JSON.stringify(obj))
            // Exemplo: garantir que timeout_tempo_hr SEMPRE seja "HH:MM:SS"
            if (out?.timeout_tempo_hr != null) {
                // se vier número, converte para string
                if (typeof out.timeout_tempo_hr === 'number') {
                out.timeout_tempo_hr = this.segundosParaHHMMSS(out.timeout_tempo_hr)
                }
            }
            return out
        },

        init() {

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)

                const el = res.data.result // agent_unit

                let liAtuadores = el['atuadores'] // lista de controladores contendo atuadores (pinos)
                let c=0
                while ( c < liAtuadores.length ) {

                    // hierarquia do documento:
                    // lista dispositivos -> lista atuadores -> 

                    // A ROTINA ABAIXO PODE SER REMOVIDA, SE liAtu e liDevices for passado via props (!) 08/01/2026

                    let params = liAtuadores[c]['params']
                    let liAtu = [] // reset
                    let j=0
                    while (j < params.length) {

                        if (params[j]['status'] == 'on' && params[j]['modelo'] == 'Periodico') { 

                            liAtu.push({
                                'tit':params[j]['titulo'],
                                'atuante':params[j]['sub_marcador'],
                                'porta':params[j]['pino']
                            })
                        }
                        j++
                    }
                    self.liDevices.push({
                        'nome_device':liAtuadores[c]['nome'], 
                        'device':liAtuadores[c]['device'], 
                        'liAtuadores':liAtu
                    })
                    self.liDevicesExib.push(liAtuadores[c]['nome'])
                    c++
                }

                // -- inicialização form.
                self.formLocal = {
                    
                    'hhmm':'08:45',
                    'device':'',
                    'titulo_atuador':'',
                    'tipo':'Direto',
                    'atu':'Desligar', // atinga key var comandoFront
                    'pino_atuador':'',
                    'corX':''
                }
            })
        },
    },

    created() { this.init() }
}
</script>
